"use client";
import * as React from "react";
const SvgStarRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 13.06 3.88 2.3c.71.43 1.58-.2 1.4-.99l-1.03-4.33 3.42-2.91a.91.91 0 0 0-.53-1.6l-4.51-.38-1.77-4.1a.94.94 0 0 0-1.72 0l-1.77 4.1-4.51.35a.91.91 0 0 0-.54 1.61l3.44 2.92-1.03 4.33c-.19.78.68 1.4 1.39.98z" }));
export {
  SvgStarRound as default
};
